import React, { useRef } from 'react';
import { makeStyles } from '~/UIKit/Style';
import { LABEL_COLOR } from '~/Constants/Colors.constants';
import { ItemCreationSubsectionInput } from './ItemCreationSubsectionInput';
import { FONT_SIZE_SMALL } from '~/Constants/UI.constants';
import { IItemCreationSubsectionInputProps } from '~/Components';
import { ItemCreationToolTip, ItemCreationToolTipProps } from './ItemCreationToolTip';

export interface ItemCreationSubsectionClasses {
  inputContainer?: string;
}

interface IItemCreationSubsectionProps<T> {
  isHeaderVisible?: boolean;
  title?: string;
  items: IItemCreationSubsectionInputProps<T>[];
  tooltip?: Omit<ItemCreationToolTipProps, 'containerRef'> | false;
  itemClasses?: ItemCreationSubsectionClasses;
  noBorder?: boolean;
  showErrorLabel?: boolean;
  isEdit?: boolean;
}

const useStyles = makeStyles((theme) => ({
  ItemCreationSubsectionContainer: {
    [theme.breakpoints.up('md')]: {
      paddingTop: 15,
    },
    '&:not(:first-of-type)': {
      paddingTop: 30,
    },
  },
  ItemCreationSubsectionTitle: {
    height: 40,
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
    fontSize: FONT_SIZE_SMALL,
    fontWeight: 'bold',
    letterSpacing: '1px',
    lineHeight: '16px',
    color: LABEL_COLOR,
    textTransform: 'uppercase',
    lineBreak: 'anywhere',
    overflow: 'hidden',
  },
}));

export const ItemCreationSubsection = <T extends object>({
  isHeaderVisible,
  title = '',
  items,
  tooltip,
  itemClasses,
  noBorder,
  showErrorLabel = false,
  isEdit = false,
}: IItemCreationSubsectionProps<T>) => {
  const { classes } = useStyles();
  const containerRef = useRef(null);

  return (
    <div className={classes.ItemCreationSubsectionContainer} ref={containerRef}>
      {isHeaderVisible && (
        <div className={classes.ItemCreationSubsectionTitle}>
          {title}
          <ItemCreationToolTip {...tooltip} containerRef={containerRef} />
        </div>
      )}
      <div className={itemClasses?.inputContainer}>
        {items.map((item, index) => (
          <ItemCreationSubsectionInput
            {...item}
            key={`subsection_${title}_input_${index}`}
            noBorder={noBorder}
            showErrorLabel={showErrorLabel}
            isEdit={isEdit}
          />
        ))}
      </div>
    </div>
  );
};
